import type React from 'react';

interface RedirectLinkProps {
  to: string;
  children: React.ReactNode;
  replace?: boolean;
  className?: string;
  isInsideLink?: boolean;
  [key: string]: any;
}

const RedirectLink: React.FC<RedirectLinkProps> = ({
  to,
  children,
  replace = false,
  className,
  isInsideLink = false,
  ...props
}: RedirectLinkProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();

    // Window checks are due to SSR
    if (replace) {
      if (window?.history) {
        window.history.replaceState({}, '', to);
      }
    } else {
      if (window?.history) {
        window.history.pushState({}, '', to);
      }
    }

    if (window?.dispatchEvent) {
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  if (isInsideLink) {
    return (
      <span
        role="link"
        tabIndex={0}
        className={className}
        onClick={handleClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter') handleClick(event);
        }}
        {...props}
      >
        {children}
      </span>
    );
  }

  return (
    <a href={to} className={className} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default RedirectLink;
